import { render, staticRenderFns } from "./Object.vue?vue&type=template&id=25704402&scoped=true&"
import script from "./Object.vue?vue&type=script&lang=js&"
export * from "./Object.vue?vue&type=script&lang=js&"
import style0 from "./Object.vue?vue&type=style&index=0&id=25704402&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25704402",
  null
  
)

export default component.exports